import { cacheDom } from '../utils/QuerySelectors.js'
import { validateEmail } from '../utils/helpers'
import { customerGetByAdmin, sendInviteEmailByAdmin } from '../utils/Customer.js'

const dom = {}
const qs = {
  section: 'data-section-type="main-login"',
  loginEmail: 'name="customer[email]"',
  activateSubmit: 'data-activate-submit',
  activateEmailSent: 'data-activate-email-sent',
}
const qsAll = {
  activateElements: 'data-activate-element',
  loginElements: 'data-login-element',
}

const state = {
  inputTimer: null,
  customer: null,
}

const enableActivateElements = (turn = false) => {
  dom.activateElements.forEach(activateElement => activateElement.classList.toggle('!hidden', !turn))
  dom.loginElements.forEach(loginElement => loginElement.classList.toggle('!hidden', turn))
}


const onEmailChange = () => {
  const email = dom.loginEmail?.value?.trim()
  if(validateEmail(email)) {
    customerGetByAdmin((res) => {
      state.customer = res.customer
      console.log('customer response', res.customer)
      if(state.customer && state.customer.state != 'ENABLED') {
        enableActivateElements(true)
      } else {
        enableActivateElements()
      }
    }, email)
  } else {
    enableActivateElements()
  }
}


export const setupMainLogin = () => {
  cacheDom(dom, qs, qsAll)
  if (dom.section) {
    dom.loginEmail.addEventListener('input', ()=> {
      clearTimeout(state.inputTimer)
      state.inputTimer = setTimeout(() => {
        onEmailChange()
      }, 300)
    })

    dom.loginEmail.addEventListener('focus', ()=> {
      onEmailChange()
    })

    dom.activateSubmit.addEventListener('click', (e) => {
      e.preventDefault()
      dom.activateSubmit.disabled = true

      sendInviteEmailByAdmin((data) => {
        if(!data?.errors.length) {
          dom.activateSubmit.querySelector('[data-activate-submit-text]').innerHTML = window.accountStrings.mainLogin.checkInbox
          dom.activateEmailSent.classList.remove('!hidden')
        }
      },
      {
        id: state.customer.id
      })
    })
  }
}
